import { observer } from "mobx-react-lite"
import { ReactNode } from "react"
import { useParams } from "../../stores/uiStore"
import { useStore } from "../../contexts/store"

import PodImageHeader from "../Pod/PodImageHeader"
import { Box } from "@mui/material"
import UxIcon, { IconIdType } from "../Elements/UxIcon"


const PageWrapper = ({children, helptext, sxCard, sxContainer, title, icon}: {children: ReactNode, helptext?: string|null, sxCard?: object, sxContainer?: object, title?: string|null, icon?: IconIdType|null}) => {
  const { uiStore } = useStore()
  const { podId, tab } = useParams()
  const deviceWidth = uiStore.deviceWidth
  const maxPageWidth = uiStore.maxPageWidth
  const paddingCard = `${uiStore.paddingContent}px`
  const paddingContainer = uiStore.paddingContainer
  const hasImageHeader = uiStore.hasImageHeader
  const showImageHeader = hasImageHeader && !(podId === undefined || tab === "pdf")

  // prevent flickering when loading screen size
  if(deviceWidth === undefined) return null

  return (
    <Box sx={{
      backgroundColor: "back.main",
      display: "grid",
      gap: "15px",
      gridTemplateRows: showImageHeader ? "max-content auto" : "auto",
      overflowY: "scroll",
      padding: paddingContainer,
      ...sxContainer
    }}>
      {showImageHeader &&
        <PodImageHeader />
      }
      <Box sx={{
        backgroundColor: "white",
        borderRadius: deviceWidth === "tiny" ? "" : "20px",
        justifySelf: "center",
        maxWidth: `${maxPageWidth}px`,
        padding: paddingCard ? paddingCard : "",
        boxShadow: 2,
        width: "100%",
        ...sxCard
      }}>
        {title &&
          <Box sx={{
            display: "grid",
            gap: "10px",
            marginBottom: "15px",
          }}>
            <Box sx={{fontSize: "20px", fontWeight: 600}}>
              {icon && deviceWidth !== 'tiny' ? <UxIcon id={icon} sx={{verticalAlign:'middle', marginRight:2, color: 'primary.main'}} /> : null}
              <span style={{verticalAlign:'middle'}}>{title}</span>
            </Box>
            {helptext && <Box sx={{marginTop:1}}>{helptext}</Box>}
          </Box>
        }
        {children}
      </Box>
    </Box>
  )
}

export default observer(PageWrapper)